module.exports = __webpack_public_path__ + "fonts/1008b6d.woff";